import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { all } from 'rsvp';

export default class AudiencesRoute extends Route {
  @service store;

  model() {
    return this.modelFor('segments.segment');
  }

  afterModel(model) {
    return all([model.get('audiences'), this.store.findAll('audience-credential')]);
  }
}
